import React, { useEffect, useState, Fragment } from 'react';
// import MetaTags from 'react-meta-tags';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Breadcrumbs from '../layouts/Breadcrumbs';
import { Helmet } from 'react-helmet';
import Content from '../sections/blogdetail/Content';
import { useParams } from 'react-router-dom';

function Blogdetail() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [blogDetails, setBlogDetails] = useState();
    let { slug } = useParams();
    // console.log(slug)

    useEffect(() => {
        (async () => {
            const response = await fetch(`https://petsgo.zimworx.site/wp-json/custom/v1/jw-single-blog/?slug=${slug}`);
            const data = await response.json();
            setBlogDetails(data);
            // console.log(data);
            // console.log(`image`, data?.featured_image);
            data.id === null && window.location.replace('/404');
        })();
    }, [slug])

    return (
        <Fragment>
            <Helmet>
                <title>{blogDetails?.title}</title>
                <meta name="description" content={blogDetails?.content} />
                <meta property="og:title" content={blogDetails?.title} />
                <meta property="og:type" content="article" />
                <meta property="og:image" content={`${blogDetails?.featured_image}`} />
                <meta property="og:url" content={`https://www.jwoliver.com/blog/${blogDetails?.slug}`} />
                <meta property="og:description" content={blogDetails?.excerpt} />
                <meta property="og:site_name" content="My Blog" />
            </Helmet>
            <Header />
            <Breadcrumbs breadcrumb={{ pagename: blogDetails?.title }} />
            <Content />
            <section className="client-section">
                <div className="container">
                </div>
            </section>
            <br />
            <br />
            <Footer />
        </Fragment>
    );

}

export default Blogdetail;